module.exports = __webpack_public_path__ + "static/media/icon12.86d0f18a.svg";